const apiUrl = () => {
    return appConfig;
  };
  
  export default apiUrl;
  